import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';import { DOCUMENT } from '@angular/common';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../app.service';
import { CustomerService } from '../GET_NEW_UI/services/customer.service';
import { AddNewUserClComponent } from './add-new-user-cl/add-new-user-cl.component';
import { CustomerContactService } from './add-new-user-cl/customer-contact.service';
import { AddNewUserElComponent } from './add-new-user-el/add-new-user-el.component';
import { AddNewUserJslComponent } from './add-new-user-jsl/add-new-user-jsl.component';
import { crsfVM, CustomerdataForExcel, CustomerIdAndNameDataSet, EquipmentTabforCuatomerContact } from './Models/customer-contact.model';
import { CustomerTab } from './Models/customer-details.model';
import { CryptoService } from '../../services/crypto.service';

@Component({
  selector: 'app-customer-contact',
  templateUrl: './customer-contact.component.html',
  styleUrls: ['./customer-contact.component.scss']
})
export class CustomerContactComponent implements OnInit {
  contactlist: any =[];


  title = 'TrackTradeUI';
  contain: Contain[] = [
    {value: 0, viewValue: 'Begins with'},
    {value: 1, viewValue: 'Contains'},
    {value: 2, viewValue: 'Ends with'}
  ]; 
  

  //selective drop down (+construction)

options: string[] = ['One', 'Two', 'Three'];

isCustomerSelected:boolean=false
  showError:boolean=false
  selectedCustomer:number=1
  selectedCustomerName_:CustomerIdAndNameDataSet[]=[]
  selectedCustomerName
  
  selectedTab:number=0
  selectedSite:string
  selectedEq:string;

  UserList:any;
  CustomerList:CustomerIdAndNameDataSet[]=[];
  contactLsit:CustomerTab[];
 
  ContactListToCL:any;
   JobsiteList:any;
   JobsiteListForTab:crsfVM[];
   JobsiteListForTabGrouping:crsfVM[];
   EquipmentListForTab:EquipmentTabforCuatomerContact[];
   customerId:any;
   customerEvalA:boolean
 
   
  constructor(public dialog: MatDialog, @Inject(DOCUMENT) private _document: Document,     
  private _customerContactService:CustomerContactService,
  private _customerService:CustomerService,
  private _appService: AppService,
  private _notify: NotificationsService,
    private crypto: CryptoService
  ) {
   
   }


  filteredOptions:   Contain[]=[
    {value: 9, viewValue: 'one'},
      {value: 1, viewValue: 'two'},
      {value: 2, viewValue: 'three'},
      {value: 3, viewValue: 'madu'},
      {value: 4, viewValue: 'chamal'},
      {value: 5, viewValue: 'abs'},
      {value: 6, viewValue: 'chess'},
      {value: 7, viewValue: 'cat'},
      {value: 8, viewValue: 'tap'}
  ]
  ngOnInit() {
  
    this.GetCustomerDetails();
   //this.getContactToCL();
  // this.GetJobSiteDetails();
  this.getcustomercontactfroexcel();
  this._appService.setPageTitle('Customer Contact');
  }


 
GetCustomerDetails(){
  this._customerContactService.GetCustomerDetails().subscribe(res=>{
    this.CustomerList = res;
    res.map(x=>{x.customerName
    x.customerId})

    console.log("this.customerlist",this.CustomerList);
})
}



GetContactbyId(){
  if(!this.selectedCustomer)
{
  return;
}
  this._customerService.getContactToCL(this.selectedCustomer).subscribe(res=>{
    
    this.contactLsit = res;

    console.log('This.cust1',res);
  })
}


GetCEquipmentsbyId(){
if(!this.selectedCustomer)
{
  return;
}
  this._customerService.GetEquipmentbyId(this.selectedCustomer).subscribe(res=>{
    //then assign it to EquipmentListForTab
    this.EquipmentListForTab = res;
   
    console.log('This.cEquipmentListForTabust',res);
  })
}




GetJobsitesbyId(){
  if(!this.selectedCustomer)
  {
    return;
  }
  this._customerService.GetJobsitebyId_(this.selectedCustomer).subscribe(res=>{
    this.JobsiteListForTab = res;
    console.log('This.this.JobsiteListForTab before',this.JobsiteListForTab);
  })
}

GetJobsitebyIdforGrouping()
{
  if(!this.selectedCustomer)
  {
    return;
  }
  this._customerService.GetJobsitebyIdforGrouping(this.selectedCustomer).subscribe(res=>{
    this.JobsiteListForTabGrouping = res;
    
    console.log('This.JobsiteListForTabGrouping',res);
  })
}


handleClick(event:any,item:any) {
  console.log(event.target.value)
}


fieldsChange(values:any,item:CustomerTab,num:number):void {
  console.log(values.checked);
  console.log(item);
if(num==1){
  item.EvalA=values.checked;
}
if(num==2){
  item.EvalB=values.checked;
}
if(num==3){
  item.EvalC=values.checked;
}
if(num==4){
  item.EvalX=values.checked;
}
if(num==5){
  item.wty_letter=values.checked;
}
if(num==6){
  item.eq_health=values.checked; 
}
if(num==7){
  item.eq_undercarriage=values.checked;
}

}

deleletecoatactList:CustomerTab[]=[];
fieldsChange_(values:any,item:CustomerTab)
{
   let array_= [];
  array_ =  this.deleletecoatactList

  if(values.checked==true){
    if(array_.length>0 ){
      let has=array_.find(x=>x.user_auto == item.user_auto)
      if(!has){
        array_.push(item);
        this.deleletecoatactList = array_;
      }
    }
    else{
      array_.push(item);
      this.deleletecoatactList = array_;
    }
    
  }else{
    this.deleletecoatactList = this.deleletecoatactList.filter(x=>x.user_auto !=item.user_auto);
  }
 
  
  console.log("this.deleletecoatactList", this.deleletecoatactList)

}

fieldsChangeJobsite(values:any,item:crsfVM,num:number):void {
  console.log(values.checked);
  console.log(item);
if(num==1){
  item.EvalA=values.checked;
}
if(num==2){
  item.EvalB=values.checked;
}
if(num==3){
  item.EvalC=values.checked;
}
if(num==4){
  item.EvalX=values.checked;
}
if(num==5){
  item.wty_letter=values.checked;
}
if(num==6){
  item.service=values.checked;
}
if(num==7){
  item.eq_undercarriage=values.checked;
}
if(num==8){
  item.eq_health=values.checked;
}
 
}


deleleteJobsiteList:crsfVM[]=[];
fieldsChangejobsite_(values:any,item:CustomerTab)
{
   let array_= [];
  array_ =  this.deleleteJobsiteList

  if(values.checked==true){
    if(array_.length>0 ){
      let has=array_.find(x=>x.user_auto == item.user_auto)
      if(!has){
        array_.push(item);
        this.deleleteJobsiteList = array_;
      }
    }
    else{
      array_.push(item);
      this.deleleteJobsiteList = array_;
    }
    
  }else{
    this.deleleteJobsiteList = this.deleleteJobsiteList.filter(x=>x.user_auto !=item.user_auto);
  }
 
  
  console.log("this.deleletecoatactList", this.deleleteJobsiteList)

}

fieldsChangeEquipment(values:any,item:EquipmentTabforCuatomerContact,num:number):void {
  console.log(values.checked);
  console.log(item);
if(num==1){
  item.EvalA=values.checked;
}
if(num==2){
  item.EvalB=values.checked;
}
if(num==3){
  item.EvalC=values.checked;
}
if(num==4){
  item.EvalX=values.checked;
}
if(num==5){
  item.wty_letter=values.checked;
}
if(num==6){
  item.service=values.checked;
}
if(num==7){
  item.eq_undercarriage=values.checked;
}

if(num==8){
  item.eq_health=values.checked;
}
 
}

deleleteEquipList:EquipmentTabforCuatomerContact[]=[];
fieldsChangeEquipment_(values:any,item:CustomerTab)
{
   let array_= [];
  array_ =  this.deleleteEquipList

  if(values.checked==true){
    if(array_.length>0 ){
      let has=array_.find(x=>x.user_auto == item.user_auto)
      if(!has){
        array_.push(item);
        this.deleleteEquipList = array_;
      }
    }
    else{
      array_.push(item);
      this.deleleteEquipList = array_;
    }
    
  }else{
    this.deleleteEquipList = this.deleleteEquipList.filter(x=>x.user_auto !=item.user_auto);
  }
 
  
  console.log("this.deleletecoatactList", this.deleleteEquipList)

}


  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  //
  openAddNewUserDialog(): void {
   // this.selectedCustomer =1;
    console.log("this.selectedcustomer",this.selectedCustomer)
    if(this.selectedCustomer>0)
    {
      this.showError=false
      if(this.selectedTab==0){
        this.openCustomerLevelDialog();
      }else if(this.selectedTab==1){
        this.openJobSiteLevelDialog();
      }else if(this.selectedTab==2){
        this.openEquipmentLevelDialog();
      }
    }else if(this.selectedCustomer<=0 || this.selectedCustomer ==null){
      this.showError=true
    }
 
    
  
}

openCustomerLevelDialog(){
  console.log("selected customer when open dialog", this.selectedCustomer)
  const dialogRef = this.dialog.open(AddNewUserClComponent, { 
    disableClose: true,
    data:{
      customerId:this.selectedCustomer,
      customerName:this.selectedCustomerName
      
      
    }
    });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){
     console.log('click add')
   }else if(result==false){
    console.log('The dialog was closed');
    this.GetContactbyId();
   }
  
  
 });
}
openJobSiteLevelDialog(){
  console.log("selected customer when open job sitedialog", this.selectedCustomer)
  console.log("JobsiteListTab__GG", this.JobsiteListForTab)
  const dialogRef = this.dialog.open(AddNewUserJslComponent, { 


    disableClose: true,
    data:{
      //siteName:this.selectedSite,
      customerId:this.selectedCustomer,
      customerName:this.selectedCustomerName,
      JobsiteListForTab:this.JobsiteListForTab//this.JobsiteListForTabGrouping
    }

    });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){
    this.GetJobsitebyIdforGrouping()
   
   }else if(result==false){
    
    this.GetJobsitesbyId();
    this.GetJobsitebyIdforGrouping()
   }

   this.GetJobsitebyIdforGrouping()
  
 });
}
openEquipmentLevelDialog(){
  const dialogRef = this.dialog.open(AddNewUserElComponent, { 
    disableClose: true,
    data:{
      //siteName:this.selectedSite,
      customerId:this.selectedCustomer,
    }
    });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){
     console.log('click add')
   }else if(result==false){
    console.log('The dialog was closed');
    this.GetCEquipmentsbyId();
   }
   
  
 });
}
onChangeCustomer(){
  this.GetJobsitebyIdforGrouping()
  console.log("SELcet ",this.selectedCustomer)

  console.log("CustomerList ",this.CustomerList)
  
  this.selectedCustomerName_=this.CustomerList.filter(x=> x.customerId==this.selectedCustomer)
  this.selectedCustomerName_.map(x=>{
    this.selectedCustomerName=x.customerName
  })
  console.log("this.selectedCustomerName", this.selectedCustomerName )
  
  this.GetContactbyId();
  this.GetCEquipmentsbyId();
  this.GetJobsitesbyId();
 
  //add next one
  this.isCustomerSelected=true;
  console.log("this.selectedCustomer",this.selectedCustomer)
}
refreshPage() {
  this._document.defaultView.location.reload();
}
/*
isCollapsed:boolean=true;
openADU(){
  this.isCollapsed=!this.isCollapsed;
}
*/



updatecustomerRow()
{
 
  this._customerService.UpdateConCL(this.contactLsit).subscribe(res =>
    {
      
    
if(res)
{ 

  this._notify.success('Updated Sucessfully');
 
}
else{
  this._notify.error("Updated Unsuccessful");

}
    })
   
    
}

updateJobsiteRow()
{
  this._customerService.UpdateConJSL(this.JobsiteListForTab).subscribe(res =>
    {
      //this._toaster.setRootViewContainerRef(this.vcr);
      if(res)
    {
      this._notify.success( 'Updated Sucessfully');
     }
     else{
      this._notify.error( 'Failed to Update');
    
    }

    })
   
    
  
}

updateEquipmentRow()
{
  this._customerService.UpdateConEL(this.EquipmentListForTab).subscribe(res =>
    {
      //this._toaster.setRootViewContainerRef(this.vcr);
      if(res)
    {
      this._notify.success( 'Updated Sucessfully');
    }
    else{
      this._notify.error( 'Failed to Update');
    
    }

    })

    
}

update()
{
  if(this.selectedTab==0){
    this.updatecustomerRow();
  }else if(this.selectedTab==1){
    this.updateJobsiteRow();
  }else if(this.selectedTab==2){
    this.updateEquipmentRow();
  }
 
}

deleteCustomerRow()
{ 
  this._customerService.DeleteCLdata(this.deleletecoatactList).subscribe(res =>
    {
if(res)
{
  this.GetContactbyId();
}
    })
    
}
deleteJobsiteRow()
{
  this._customerService.DeleteJSdata(this.deleleteJobsiteList).subscribe(res =>
    {
if(res)
{
  this.GetJobsitesbyId();
}
    })
    
}
deleteEquipmentRow()
{
  
  this._customerService.deleteEqData(this.deleleteEquipList).subscribe(res =>
    {
      if(res)
      {
        this.GetCEquipmentsbyId();
      }

    })
    
}

delete()
{
  if(this.selectedTab==0){
    this.deleteCustomerRow();
  }else if(this.selectedTab==1){
    this.deleteJobsiteRow();
  }else if(this.selectedTab==2){
    this.deleteEquipmentRow();
  }
  

 
}

CustomerdataForExcel_:CustomerdataForExcel[]
getcustomercontactfroexcel()
{
  this._customerService.getcustomercontactfroexcel().subscribe(res =>{
this.CustomerdataForExcel_=res
  })
}

DownloadCSVFile() { 
  this.downloadFile(this.CustomerdataForExcel_)
  //alert("Export to Excel")
 // this._toaster.success( 'Export to Excel');

}

downloadFile(data: any) {
 
  console.log("data", data)

 

  let _data = []

  data.map(p => {
    let _o = {}
    for (var key in p) {
      if (p.hasOwnProperty(key)) {

        if(key == "EvalA"){
          _o["EvalA"] = p[key] 
        }else if(key == "EvalB"){
          _o["EvalB"] = p[key]
        }else if(key == "EvalC"){
          _o["EvalC"] = p[key]
        }else if(key == "EvalX"){
          _o["EvalX"] = p[key]
        }else if(key == "sendemail"){
          _o["sendemail"] = p[key]
        }else if(key == "userName"){
          _o["userName"] = this.crypto.decrypt(p[key])
        }else if(key == "type"){
          _o["type"] = p[key]
        }else if(key == "email"){
          _o["email"] = this.crypto.decrypt(p[key])
        }
        else if(key == "phone"){
          _o["phone"] = this.crypto.decrypt(p[key])
        }else if(key == "sendemail"){
          _o["sendemail"] = p[key]
        }
      }
  }

  _data.push(_o)
  })

  const replacer = (key, value) => value === null ? '' : value; 
  const header = Object.keys(_data[0]);
  let csv = _data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
  csv.unshift(header.join(','));
  let csvArray = csv.join('\r\n');
  var a = document.createElement('a');
  var blob = new Blob([csvArray], { type: 'text/csv' }),
    url = window.URL.createObjectURL(blob);

  a.href = url;
  a.download = `Export Customer Access and Contacts.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}


}


export interface Contain {
  value: number;
  viewValue: string;
}





